    <script>
    import ThreeDotsLoader from "./AnimationDotsLoader.vue";
    export default {
        props: {
            message: Object,
            type: String,
            icons: Object,
            showLoader: Boolean
        },
        components: {
            ThreeDotsLoader
        },
        data() {
            return {
                loading: false
            }
        },
        computed: {
            userStyles() {
                return {
                    maxWidth: '80%'
                }
            },
            botStyles() {
                return {
                    maxWidth: '80%',
                }
            }
        },
        watch: {
            message: {
                handler(newVal) {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                    }, 1500);
                },
                immediate: true,
            },
        },
    }
    </script>

    <template>
        <li class="list__item" v-if="message">
            <div v-if="message.question" class="demo__user-wrapper">
                <div class="icon_wrapper icon_wrapper--user">
                    <span>You</span>
                </div>
                <div class="demo__user-message" :style="userStyles">
                    <ThreeDotsLoader v-if="loading && showLoader" type="user" />
                    <p v-else class="demo__message-text question_text">{{ message.question }}</p>
                </div>
            </div>

            <div v-if="message.answer" class="demo__bot-wrapper">
                <div v-if="icons?.agentIcon" class="icon_wrapper">
                    <div class="demo__chat-icon">
                        <img :src="icons.agentIcon" alt="" />
                    </div>
                    <span>ChatBot</span>
                </div>
                <div class="demo__bot-message" :class="{ error: message.error }" :style="botStyles">
                    <ThreeDotsLoader v-if="loading && showLoader" type="bot" />
                    <p v-else class="demo__message-text bot_text" v-html="message.answer"></p>
                </div>
            </div>
        </li>
    </template>

    <style scoped lang="scss">
    .list__item {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .demo__bot-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .demo__bot-message {
        font-family: 'Inter', sans-serif;
        margin: 0;
        padding: 12px 20px;
        border-radius: 4px 16px 16px 16px;
        color: #fff;
        font-weight: 500;
        line-height: 1.5;
        margin-right: auto;
        background-color: #fff;

        &.error {
            background-color: transparent !important;
            border: 1px solid #eb5757;
            color: #eb5757;
        }

        ;
    }

    .demo__user-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        gap: 8px;
    }

    .demo__user-message {
        font-family: 'Inter';
        margin: 0;
        padding: 12px 20px;
        border-radius: 16px 4px 16px 16px;
        background-color: #0165FF;
        font-size: 1em;
        font-weight: 500;
        line-height: 1.5;
        align-self: flex-end;
    }

    .demo__message-text {
        font-family: inherit;
        padding: 0;
        margin: 0;
        font-size: 1em;
        font-weight: 500;
        line-height: 1.5;
        max-width: 100%;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    .question_text {
        color: #fff;
    }

    .bot_text {
        color: #333;
    }

    .icon_wrapper {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 500;

        &--user {
            place-self: flex-end;
        }
    }

    .demo__chat-icon {
        overflow: hidden;
        position: relative;
        border-radius: 50%;
        object-fit: cover;
        min-width: 17px;
        max-width: 17px;
        height: 17px;

        & img {
            position: absolute;
            top: 0;
            height: 0;
            width: 100%;
            height: 100%;
        }
    }

    .chatbot_preview__time {
        font-family: inherit;
        margin-top: 3px;
        padding: 0;
        color: #4f4f4f;
        text-align: right;
        font-size: 0.7em;
        font-weight: 400;
        line-height: 1.33;
        text-align: right;
        opacity: 0.6;

        &--left {
            color: #fff;
        }

        &.error {
            color: #eb5757;
        }
    }</style>